window.AcademiaSharing = {};